"use client";

import React from 'react';
import '@/app/styles/footer.css';
import { Phone, Mail } from 'lucide-react';
import Image from 'next/image';

const Footer = () => {
  return (
    <footer className="bigd-footer" style={{
      WebkitTextSizeAdjust: '100%',
      lineHeight: '1.4285em',
      color: 'rgba(0, 0, 0, .87)',
      fontSize: '14px',
      fontFamily: 'Arial,serif',
      boxSizing: 'inherit',
      backgroundColor: '#f9f9f9',
      marginBottom: 0,
      padding: '0 15px 10px 15px'
    }}>
      <div className="">
        <div className="bigd-panel-body">
          <div className="bigd-container-fluid">
            <div className="bigd-row">
              <div className="bigd-col-md-3">
                <a href="https://ngdc.cncb.ac.cn" target="_blank" rel="noopener noreferrer">
                  <div style={{ position: 'relative', width: '200px', height: '60px', marginTop: '15px' }}>
                    <Image
                      src={`${process.env.basePath || ''}/logo/ngdc-logo-blue.png`}
                      alt="NGDC Logo"
                      fill
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                </a>
                <h3 className="bigd-text-primary" style={{ color: '#051133', fontWeight: 'bold' }}>National Genomics Data Center</h3>
                <ul className="bigd-list-unstyled">
                  <li className="flex items-center">
                    <Phone className="w-4 h-4 mr-2" />
                    86-10-84097298
                  </li>
                  <li className="flex items-center">
                    <Mail className="w-4 h-4 mr-2" />
                    ngdc(at)big.ac.cn
                  </li>
                  <li><a href="https://ngdc.cncb.ac.cn/policies" style={{ color: '#014376' }}>Policies and Disclaimers</a></li>
                </ul>
              </div>
              <div className="bigd-col-md-9">
                <div className="bigd-col-md-2">
                  <h3 style={{ color: '#051133', fontWeight: 'bold' }}>Research &amp; Resources</h3>
                  <ul className="bigd-list-unstyled">
                    <li><a href="https://ngdc.cncb.ac.cn/databases" style={{ color: '#014376' }}>Databases</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/bit" style={{ color: '#014376' }}>Tools</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/standards" style={{ color: '#014376' }}>Standards</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/research" style={{ color: '#014376' }}>Topics &amp; Projects</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/publications" style={{ color: '#014376' }}>Publications</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/annual-report" style={{ color: '#014376' }}>Annual Reports</a></li>
                  </ul>
                </div>
                <div className="bigd-col-md-2">
                  <h3 style={{ color: '#051133', fontWeight: 'bold' }}>Featured</h3>
                  <ul className="bigd-list-unstyled">
                    <li><a href="https://ngdc.cncb.ac.cn/databasecommons" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>Database Commons</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/genbase/" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>GenBase</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/gsa" target="_blank" rel="noopener noreferrer" title="Genome Sequence Archive" style={{ color: '#014376' }}>GSA</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/gwh" target="_blank" rel="noopener noreferrer" title="Genome Warehouse" style={{ color: '#014376' }}>GWH</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/gvm" target="_blank" rel="noopener noreferrer" title="Genome Variation Map" style={{ color: '#014376' }}>GVM</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/gen" target="_blank" rel="noopener noreferrer" title="Gene Expression Nebulas" style={{ color: '#014376' }}>GEN</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/ncov/" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>RCoV19</a></li>
                  </ul>
                </div>
                <div className="bigd-col-md-3">
                  <h3 style={{ color: '#051133', fontWeight: 'bold' }}>Alliance &amp; Collaboration</h3>
                  <ul className="bigd-list-unstyled">
                    <li><a href="https://ngdc.cncb.ac.cn/bhbd-alliance" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>BHBD</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/p10k/" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>P10K</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/partners" style={{ color: '#014376' }}>Partners</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/collaborations" style={{ color: '#014376' }}>Collaborations</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/funding" style={{ color: '#014376' }}>Funding</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/contact" style={{ color: '#014376' }}>Contact Us</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/news/80" style={{ color: '#014376' }}>Join Us</a></li>
                  </ul>
                </div>
                <div className="bigd-col-md-3">
                  <h3 style={{ color: '#051133', fontWeight: 'bold' }}>Conference &amp; Outreach</h3>
                  <ul className="bigd-list-unstyled">
                    <li><a href="https://ngdc.cncb.ac.cn/conference" style={{ color: '#014376' }}>Conferences</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/education" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>Education</a></li>
                  </ul>
                </div>
                <div className="bigd-col-md-2">
                  <h3 style={{ color: '#051133', fontWeight: 'bold' }}>About</h3>
                  <ul className="bigd-list-unstyled">
                    <li><a href="https://ngdc.cncb.ac.cn/about" style={{ color: '#014376' }}>About NGDC</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/people" style={{ color: '#014376' }}>People</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/mission" style={{ color: '#014376' }}>Mission</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/board" style={{ color: '#014376' }}>Advisory Board</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/structure" style={{ color: '#014376' }}>Organizational Structure</a></li>
                    <li><a href="https://ngdc.cncb.ac.cn/history" style={{ color: '#014376' }}>History</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <hr className="footer-hr" />
            <div className="bigd-container">
              <div className="bigd-row">
                <div className="bigd-col-md-3 bigd-center-block">
                  <div style={{ position: 'relative', width: '150px', height: '50px', marginRight: '15px' }}>
                    <Image 
                      src={`${process.env.basePath}/logo/cncb-logo.png`}
                      alt="CNCB Logo"
                      fill
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                </div>
                <div className="bigd-col-lg-offset-1 bigd-col-md-8">
                  <p className="bigd-text-muted">© 2025 <a href="https://www.cncb.ac.cn" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>China National Center for Bioinformation / </a><a href="http://www.big.ac.cn" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>Beijing Institute of Genomics</a>, <a href="https://www.cas.cn" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>Chinese Academy of Sciences</a><br />No.1 Beichen West Road, Chaoyang District, Beijing 100101, China<br /></p>
                  <p className="bigd-text-muted"><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{ color: '#014376' }}>京ICP备10050270号</a><br /></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 